import { Skeleton, Stack } from '@mui/material'
import React from 'react'

const ProfileSkeleton = ({ style }) => {
  return (
    <Stack style={style} direction='row' alignItems={'center'} spacing={0.5} sx={{ p: 1 }}>
      <Skeleton animation={'wave'} variant='circular' width={40} height={40} />
      <Stack sx={{ flex: 1 }}>
        <Skeleton animation={'wave'} variant='text' height={15} sx={{ fontSize: '1rem' }} />
        <Skeleton animation={'wave'} variant='text' height={15} sx={{ fontSize: '1rem' }} />
      </Stack>
    </Stack>
  )
}

export default ProfileSkeleton
